import React from "react";
import { Link } from "react-router-dom";
import "./Css/Sidebar.css";

export default function Sidebar({ className }) {
  return (
    <div className={className}>
      <div className="sidebar-content">
        <h2>BACKOFFICE</h2>
        <ul>
          <li><Link to="/dashboard">Audio Control</Link></li>
          <li><Link to="/playlists">Playlists</Link></li>
          <li><Link to="/tasks">Tasks</Link></li>
          <li><Link to="/users/all">Users</Link></li>
          <li><Link to="/whitelist">Whitelist IPs</Link></li>
        </ul>
      </div>
    </div>
  );
}
